const state = {
  historicoSla: Array
}

const mutations = {
  setHistoricoSla (state, obj) {
    state.historicoSla = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/historicoSla.js